var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStrmCycle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 18.75 18.75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 9306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4714 6.34447L14.458 9.09184C14.428 9.17259 14.3739 9.24219 14.3032 9.29138C14.2324 9.34057 14.1483 9.36689 14.0621 9.36689C13.9759 9.36689 13.8918 9.34057 13.821 9.29138C13.7502 9.24219 13.6962 9.17258 13.6662 9.09184L12.6528 6.34446C12.6314 6.2865 12.5977 6.23385 12.554 6.19015C12.5102 6.14645 12.4575 6.11278 12.3994 6.09135L9.6495 5.07894C9.56869 5.04897 9.499 4.99501 9.44978 4.92431C9.40056 4.85362 9.37418 4.76957 9.37418 4.68345C9.37418 4.59733 9.40056 4.51328 9.44978 4.44258C9.499 4.37188 9.56868 4.31793 9.6495 4.28796L12.3994 3.27551C12.4575 3.25414 12.5102 3.22044 12.5539 3.17674C12.5977 3.13305 12.6314 3.08038 12.6528 3.0224L13.6662 0.275063C13.6962 0.194328 13.7502 0.124697 13.821 0.0755254C13.8917 0.0263624 13.9759 5.03311e-06 14.0621 5.12739e-06C14.1483 5.22167e-06 14.2324 0.0263628 14.3032 0.0755259C14.3739 0.124697 14.4279 0.194329 14.4579 0.275064L15.4714 3.0224C15.4928 3.08039 15.5265 3.13305 15.5702 3.17675C15.614 3.22044 15.6667 3.25414 15.7247 3.27551L18.4747 4.28797C18.5555 4.31794 18.6252 4.37189 18.6744 4.44259C18.7236 4.51329 18.75 4.59734 18.75 4.68346C18.75 4.76958 18.7236 4.85363 18.6744 4.92432C18.6252 4.99502 18.5555 5.04898 18.4747 5.07895L15.7247 6.09135C15.6667 6.11278 15.614 6.14645 15.5702 6.19015C15.5265 6.23386 15.4928 6.28651 15.4714 6.34447Z",
    fill: "url(#paint0_linear_0_4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 147",
    cx: 7.56899,
    cy: 2.83837,
    rx: 7.56899,
    ry: 2.83837,
    transform: "matrix(-0.708867 -0.705342 -0.708867 0.705342 15.8091 13.7966)",
    stroke: "url(#paint1_linear_0_4)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 148",
    d: "M15.8946 10.4344C15.8946 14.6128 12.5044 18 8.32232 18C4.14024 18 0.75 14.6128 0.75 10.4344C0.75 6.25608 4.14024 2.86886 8.32232 2.86886",
    stroke: "url(#paint2_linear_0_4)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 14.0621,
    y1: 0.00000512739,
    x2: 14.0621,
    y2: 9.36689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4",
    x1: 7.56899,
    y1: 0,
    x2: 7.56899,
    y2: 5.67674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_4",
    x1: 8.32232,
    y1: 2.86886,
    x2: 8.32232,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStrmCycle);
export default __webpack_public_path__ + "static/media/icon-strm-cycle.5451614fc6de553148c428de369eded0.svg";
export { ForwardRef as ReactComponent };